export default __webpack_public_path__ + "static/media/future_craft.24ca57c6.svg";